import { forwardRef, type Ref, type SVGProps } from "react";
const IconRestaurantOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.842 3.007a.536.536 0 0 0-.451.5l-.386 6.95a3 3 0 0 0 1.12 2.509l.543.434a2 2 0 0 1 .75 1.561V29a1 1 0 0 0 2 0V14.946a2 2 0 0 1 .752-1.546l.542-.434a3 3 0 0 0 1.121-2.51l-.386-6.95a.536.536 0 0 0-1.07-.015l-.438 5.261a.27.27 0 0 1-.538-.003l-.447-6.25a.536.536 0 0 0-1.07 0l-.447 6.25a.27.27 0 0 1-.348.24.27.27 0 0 1-.19-.237l-.44-5.26a.536.536 0 0 0-.617-.485m1.533 8.397.543.434.152.124c.175.143.262.215.349.215s.174-.072.348-.215l.153-.124.543-.434c.089-.072.434-.404.207-.404h-2.503c-.226 0 .119.332.208.404m8.176 2.1c-1.542-.881-2.438-2.651-2.26-4.42.306-3.07.915-7.084 4.128-7.084s3.822 4.015 4.13 7.085c.176 1.768-.72 3.538-2.261 4.419A1.72 1.72 0 0 0 21.419 15v14a1 1 0 1 1-2 0V14.976a1.72 1.72 0 0 0-.868-1.472m.915-1.78c.773.441 1.133.441 1.906 0 .764-.437 1.285-1.447 1.186-2.44-.155-1.554-.367-3.037-.824-4.108-.22-.514-.444-.804-.63-.959-.15-.123-.338-.217-.685-.217-.346 0-.534.094-.684.217-.186.155-.411.445-.63.96-.458 1.07-.67 2.553-.825 4.107-.099.993.422 2.003 1.186 2.44"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconRestaurantOutlineSVG);
ForwardRef.displayName = "IconRestaurantOutline";
export { ForwardRef as IconRestaurantOutline };
